import { Sparkles } from "lucide-react";
import { useFeedback } from "@/context/FeedbackContext";

export default function FeedbackBar() {
  const { openFeedback } = useFeedback();
  return (
    <div className="bg-[#4A5D4E]/[0.06] border-b border-[#E8E3D9]" data-testid="feedback-bar">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-2 flex items-center justify-center gap-x-3 gap-y-1 flex-wrap text-center">
        <span className="inline-flex items-center gap-1.5 text-sm text-[#6E6860]">
          <Sparkles className="h-3.5 w-3.5 text-[#C4A265]" strokeWidth={1.75} />
          Common Ground Explorer is in active development — we'd love your feedback to help us improve.
        </span>
        <button
          onClick={openFeedback}
          data-testid="feedback-bar-button"
          className="text-sm font-medium text-[#4A5D4E] hover:text-[#3B4A3E] underline underline-offset-4"
        >
          Share feedback
        </button>
      </div>
    </div>
  );
}
